module.exports = "/images/vendor/flag-icon-css/flags/1x1/bf.svg?48eb94de0b25013f341693acc2abb3b2";